import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import React from "react";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Accordion, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "../../Assets/Styles/pages/imageProperties.scss";
import { emoticons } from "../../Config/emoji";
import {
  setActiveStickersSrc,
  setRecentlyUsed,
} from "../../Redux/Stickers/stickersSlice";
import _ from "lodash";
import helper_functions from "../../Config/helper_functions";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { setItem } from "../../Redux/WaterMarks/wateramarks";

const Stickers = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [value, setValue] = useState("Emojis");
  const [choice, setChoice] = useState(null);
  const [family, setFamily] = useState([]);
  const [recentlyUsed, setRecently] = useState([]);

  const stickerState = useSelector((state) => state["stickers"]);

  const setFocus = () => {
    setChoice(null);
  };
  const canvasRef = useRef(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dragSticker = async (e, drag) => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d", {
      willReadFrequently: true,
    });
    canvas.width = 1000;
    ctx.font = `${850}px Arial`;

    ctx.textAlign = "center";

    // Write text onto the canvas
    ctx.fillText(e.emoji, canvas.width / 2, (canvas.height + 600) / 2);
    // Convert canvas to base64 string
    var dataUrl = await canvas.toDataURL();

    dataUrl = helper_functions.dataURLtoFile(
      dataUrl,
      e.description.replace(/\s/g, "") + ".png"
    );

    if (drag) dragSave(dataUrl, e);
    else addSticker(dataUrl, e);

    dispatch(setRecentlyUsed(e));
  };

  const dragSave = (dataUrl, sticker) => {
    dispatch(
      setActiveStickersSrc(
        {
          dataUrl,
          sticker,
        } //full object of sticker to save in recently used from canvas on drop.
      )
    );
  };
  const addSticker = (dataUrl) => {
    let ID = Date.now();

    dispatch(
      setItem({
        type: "image",
        property: "sticker",
        id: ID,
        x: 50,
        y: 50,
        deg: 0,
        scaleX: 0.25,
        scaleY: 0.25,
        src: dataUrl,
        opacity: 1,
        name: dataUrl.name,
        size: dataUrl.size,
      })
    );
  };

  const OnSearch = async (event) => {
    let searchString = event.target.value;
    const categories = {};

    emoticons.forEach((emoji) => {
      const { description, aliases, tags, category } = emoji;

      if (
        description.includes(searchString) ||
        aliases.some((alias) => alias.includes(searchString)) ||
        tags.some((tag) => tag.includes(searchString))
      ) {
        if (!categories[category]) {
          categories[category] = [];
        }
        categories[category].push(emoji);
      }
    });
    const entries = Object.entries(categories);
    setFamily(entries);
  };
  useEffect(() => {
    const effectFunc = async () => {
      let categories = _.groupBy(emoticons, (emoji) => emoji.category);
      const entries = await Object.entries(categories);
      setFamily(entries);
    };

    effectFunc();
  }, []);
  useEffect(() => {
    const effectFunc = async () => {
      let used = [...stickerState.recentlyUsed];
      let array = _.reverse(used);
      setRecently(array);
    };

    effectFunc();
  }, [stickerState.recentlyUsed]);

  return (
    <Row className="text_16 productSans m-0 p-0">
      <TabContext value={value}>
        <Row className="m-0 p-0 px-0 border-bottom">
          <Box
            sx={{ width: "100%", paddingLeft: "0rem", paddingRight: "0rem" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              className="Aktiv p-0"
              aria-label="secondary tabs example"
            >
              <Tab value="Emojis" label={t("Stickers.Emojis")} />
              <Tab value="Stickers" label={t("Stickers.Stickers")} />
            </Tabs>
          </Box>
        </Row>
        <Row className="px-0 m-0">
          <TabPanel value="Emojis" className="m-0 p-0">
            <Row className="my-3 p-0 m-0">
              <TextField
                variant="filled"
                placeholder="Search"
                onChange={OnSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        marginTop: "0px !important",
                        display: "flex",
                        alignSelf: "center",
                      }}
                    >
                      <SearchIcon fontSize="small" sx={{ opacity: 0.6 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiFilledInput-root": {
                    borderRadius: "0.5vw",
                    backgroundColor: "white",
                    border: "1.5px solid rgba(207, 207, 207, 1)",
                  },
                  "& .MuiFilledInput-input": {
                    paddingTop: "0.5rem",
                    paddingBottom: "0.5rem",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "start",
                    fontFamily: "productSans",
                    fontSize: "1rem",
                  },
                  "& .MuiFilledInput-underline:before": {
                    display: "none",
                  },
                  "& .MuiFilledInput-underline:after": {
                    display: "none",
                  },
                  "& .MuiInputLabel-filled": {
                    textAlign: "center",
                  },
                }}
              />
            </Row>

            <Accordion
              className="mx-0"
              defaultActiveKey={0}
              alwaysOpen
              activeKey={choice}
              flush
            >
              {recentlyUsed.length ? (
                <>
                  <Row className="m-0 p-0 text_14 productSans border-bottom w-100 pb-3">
                    Recently used
                  </Row>
                  <Row className="">
                    {}
                    {recentlyUsed?.map((data, i) => {
                      return (
                        <div
                          key={i}
                          className="p-2 px-0 w_3rem mx-3 sizeSticker"
                          draggable="true"
                          onDragStart={() => dragSticker(data, 1)}
                          onClick={() => dragSticker(data, 0)}
                          title={data.description}
                        >
                          {data.emoji}
                        </div>
                      );
                    })}
                  </Row>
                </>
              ) : null}
              {family &&
                Object.keys(family)?.map((key, index) => {
                  return (
                    <>
                      <Accordion.Item
                        className="border-0"
                        eventKey={parseInt(index)}
                      >
                        <Accordion.Header
                          className={`text_14 ${
                            choice === parseInt(index)
                              ? "accordion-button-border-focused"
                              : ""
                          } productSans`}
                          onClick={() => {
                            choice !== parseInt(index)
                              ? setChoice(parseInt(index))
                              : setFocus(parseInt(index));
                          }}
                          as="h4"
                        >
                          {family[key][0]}
                        </Accordion.Header>
                        <Accordion.Body className="p-0 m-0">
                          <Row>
                            {family[key][1]?.map(
                              (data, i) =>
                                data.emoji.length < 5 && (
                                  <div
                                    key={i}
                                    className="p-2 px-0 w_3rem mx-3 sizeSticker"
                                    draggable="true"
                                    onDragStart={() => dragSticker(data, 1)}
                                    onClick={() => dragSticker(data, 0)}
                                    title={data.description}
                                  >
                                    {data.emoji}
                                  </div>
                                )
                            )}
                          </Row>
                        </Accordion.Body>
                      </Accordion.Item>
                    </>
                  );
                })}
            </Accordion>
          </TabPanel>
        </Row>
        {/* <TabPanel value="Stickers">
                    {stickers?.map((sticker, id) => {
                        return (
                            <div key={id}>
                                <p className='text_14 CamptonMedium'>{sticker.family}</p>
                                {sticker.data?.map((data, id) => {
                                    return (
                                        <img
                                            key={id}
                                            className="stickersImage p-0 my-4 mx-2"
                                            src={data.src}
                                            alt={data.src}
                                            draggable="true"
                                            onDragStart={(e) => {
                                                dragSticker(e);
                                            }
                                            }
                                        />
                                    );
                                })
                                }
                            </div>
                        );
                    })}
                </TabPanel> */}
      </TabContext>
      <canvas ref={canvasRef} width="1000" height="1000" className="d-none" />
    </Row>
  );
};

export default Stickers;
